<div class="prompt-library-container">
  <div class="prompt-library-title">
    <h4>Automation Library</h4>
    <button matIconButton type="button" #tooltip="matTooltip"
      aria-label="How to use the Automation Library" [matTooltip]="tooltipText"
      matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true" fontIcon="info" />
    </button>
  </div>

  <!-- Search bar -->
  <div class="prompt-library-search-input">
    <mat-form-field class="prompt-library-search-input-field">
      <mat-label>Search</mat-label>
      <input matInput type="text" [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)"
        placeholder="Search by name or description">
      @if (searchTerm()) {
        <button matIconButton type="button" matSuffix aria-label="Clear search" (click)="clearSearch()">
          <mat-icon class="material-symbols-outlined icon-sm icon-action">close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <!-- Collapsible sections -->
  <ul class="section-list">
    <!-- Instructions Section -->
    <li class="section-item">
      <button
        type="button"
        class="section-toggle"
        [class.rotate]="instructionsOpen()"
        (click)="toggleInstructions()"
        [attr.aria-expanded]="instructionsOpen()"
        aria-controls="instructions-panel">
        <span>Prompts and Instructions</span>
        <mat-icon class="material-symbols-outlined" aria-hidden="true" fontIcon="keyboard_arrow_down" />
      </button>
      <div id="instructions-panel" class="section-content" [class.show]="instructionsOpen()">
        <div>
          <div class="prompt-list-container">
            <app-prompt-library-list
              [data]="instructions()"
              [title]="'Prompts and Instructions'"
              [isAutomationDisabled]="isAutomationActive()" />
          </div>
        </div>
      </div>
    </li>

    <!-- Workflows Section -->
    <li class="section-item">
      <button
        type="button"
        class="section-toggle"
        [class.rotate]="workflowsOpen()"
        (click)="toggleWorkflows()"
        [attr.aria-expanded]="workflowsOpen()"
        aria-controls="workflows-panel">
        <span>Workflows</span>
        <mat-icon class="material-symbols-outlined" aria-hidden="true" fontIcon="keyboard_arrow_down" />
      </button>
      <div id="workflows-panel" class="section-content" [class.show]="workflowsOpen()">
        <div>
          <div class="prompt-list-container">
            <app-prompt-library-list
              [data]="workflows()"
              [title]="'Workflows'"
              [isAutomationDisabled]="isAutomationActive()" />
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
